module.exports = __webpack_public_path__ + "img/太阳_sun.3ede8c43.png";